"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentState = void 0;
var AssessmentState;
(function (AssessmentState) {
    AssessmentState["NOT_READY_FOR_ASSESSMENT"] = "NOT_READY_FOR_ASSESSMENT";
    AssessmentState["READY_FOR_ASSESSMENT"] = "READY_FOR_ASSESSMENT";
    AssessmentState["READY_FOR_UPDATED_ASSESSMENT"] = "READY_FOR_UPDATED_ASSESSMENT";
    AssessmentState["READY_FOR_RM_RERUN"] = "READY_FOR_RM_RERUN";
    AssessmentState["SENT_FOR_ASSESSMENT"] = "SENT_FOR_ASSESSMENT";
    AssessmentState["FAILED_TO_SEND_FOR_ASSESSMENT"] = "FAILED_TO_SEND_FOR_ASSESSMENT";
    AssessmentState["WITHDRAWN"] = "WITHDRAWN";
    AssessmentState["READY_FOR_WITHDRAWAL"] = "READY_FOR_WITHDRAWAL";
})(AssessmentState = exports.AssessmentState || (exports.AssessmentState = {}));
